/**
 * Configuration class for casino-related settings.
 * Controls how casino games are launched (in-window or detached).
 * Candidate to be a Poker Setting
 */
class CasinoConfigClass {
    /**
     * When true, casino games launch in a separate detached window.
     * When false, casino games launch within the main poker client window (current behavior).
     */
    public launchInDetachedWindow: boolean = true;

    /**
     * Default window features for detached casino game windows.
     */
    public readonly detachedWindowFeatures = 'width=1280,height=800,menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes,status=no';
}

export const CasinoConfig = new CasinoConfigClass();
